import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client';

import { GetSavedSearchesDocument, GetSavedSearchesQuery, GetSavedSearchesQueryVariables } from './savedSearches.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

const defaultOptions = { client: apolloClientContracts } as const;

export function useGetSavedSearchesLazyQuery(
  baseOptions?: LazyQueryHookOptions<
  GetSavedSearchesQuery,
  GetSavedSearchesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useLazyQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(
    GetSavedSearchesDocument,
    options,
  );
}